module.exports = __webpack_public_path__ + "img/ch83.d835fb4f.jpg";